export const CSendMoneyErrorTitles = {
    PARENT_BALANCE: 'Get Parent Balance',
    PARENT_FUNDING: 'Send Transaction'
}